import React from 'react';
import { createStore } from "redux";
import { connect } from "react-redux";
import i18n from '../utils/i18n';

// Actions
const INITIALIZE = "INITIALIZE";
const SET_NEXT_STEP = "SET_NEXT_STEP";
const SET_COURSE_INFO = "SET_COURSE_INFO";
const SET_EMAIL_INTENT = "SET_EMAIL_INTENT";
const SET_SELECTED_GRADE = "SET_SELECTED_GRADE";
const SET_TEACHER_DETAILS = "SET_TEACHER_DETAILS";
const SET_CHANGE_EMAIL_STATE = "SET_CHANGE_EMAIL_STATE";
const SET_STUDENTS_LIST = "SET_STUDENTS_LIST";

// Initial State
const initialState = (data) => {
  if (data.locale) {
    i18n.changeLanguage(data.locale);
    localStorage.setItem('user_preferred_language', data.locale);
  }
  return {
    lastStep: data.last_step,
    currentUser: data.current_user || {},
    grades: data.grades || [],
    intent: data.email_verification_intent || {},
    selectedCourse: data.selected_course || {},
    contentGroups: data.content_groups || [],
    isClassroomLinked: data.is_classroom_linked,
    teacherDetails: {},
    selectedGrade: "",
    courses: data.courses || {},
    showWeeklyGoalOnboarding: data.show_weekly_goal_onboarding,
    showReminderText: data.show_reminder_text,
    hideLogoutOnOtp : data.hide_logout_on_otp,
    isBackButtonLoading: false,
    hideLogoutOnOtp: data.hide_logout_on_otp,
    showChangeEmailLink: data.show_change_email_link || false,
    studentsList: data.students_list || [],
  }
};

// Root Reducer
export const rootReducer = (state = {}, action) => {
  switch (action.type) {
    case INITIALIZE:
      return initialState(action.payload);
    case SET_NEXT_STEP:
      return { ...state, lastStep: action.payload };
    case SET_COURSE_INFO:
      return {
        ...state,
        selectedCourse: action.payload.selected_course,
        contentGroups: action.payload.content_groups,
        courses: action.payload.courses,
        currentPoqCourse: action.payload.selected_course,
      };
    case SET_EMAIL_INTENT:
      return { ...state, intent: action.payload };
    case SET_TEACHER_DETAILS:
      return { ...state, teacherDetails: action.payload };
    case SET_SELECTED_GRADE:
      return { ...state, selectedGrade: action.payload };
    case SET_CHANGE_EMAIL_STATE:
      return { ...state, showChangeEmailLink: action.payload };
    //set students for select student profile screen during PTL Signup through common link
    case SET_STUDENTS_LIST:
      return { ...state, studentsList: action.payload};
    default:
      return state;
  }
};

const Store = createStore(rootReducer);

export default function ConnectWithStore(mapStateToProps, dispatchStateToProps, component) {
  var ConnectedComponent = connect(mapStateToProps, dispatchStateToProps)(component);
  return function (props) {
    return <ConnectedComponent {...props} store={Store} />
  }
}

